import React from 'react';
import {StyleSheet} from 'react-native';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from '../AVText';
import {getDescriber} from 'src/components/elements/account/descriptor/DescriptorType';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';

type PointsEarnedProps = {
  points?: number;
};

const PointsEarned = (props: PointsEarnedProps) => {
  const rewardPoints = props.points ?? 0;
  return rewardPoints > 0 ? (
    <AVText
      style={[
        getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        styles.pointsText,
      ]}
    >
      {props.points + ' ' + Localized.Labels.points_earned}
    </AVText>
  ) : null;
};

const styles = StyleSheet.create({
  pointsText: {
    marginTop: -Styles.Spacing.m1,
    fontSize: Styles.Fonts.f1,
    color: getDescriber().getStyleDescriptor(true, 'Mobile Purchase').points
      ?.color,
    fontWeight: '400',
    marginBottom: Styles.Spacing.m1,
  },
});

export default PointsEarned;
